import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import BreadCrumb from "@/components/Common/BreadCrumb";
import Image from "next/image";
import Link from "next/link";
import enrolmentImg from "../../public/images/enrollment/Flyer_admisiones.png";
import pricing2026Img from "../../public/images/enrollment/precios_2026.png";

const Enrolment = () => {
  return (
    <>
      <PageHead title="Admisiones - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <BreadCrumb 
            title="Admisiones - 2027" 
            text="Admisiones" 
            actionButtonText="Reserva tu cupo"
            actionButtonLink="https://forms.zohopublic.com/daniel104/form/ReservadecupoColegioMenfis2027/formperma/hkgJC8jbOl0QPHzJj5tyOr54hOYi9P6UJW7AIfbVsCo"/>
          <div className="bg-color-white rbt-section-gapTopHalf">
            <div className="container">
              <div className="row g-5 align-items-center">
                <div className="col-lg-6">
                  <Image
                    className="w-100 rbt-radius"
                    src={enrolmentImg}
                    width={407}
                    height={638}
                    property="true"
                    alt="Enrollment info flyer"
                  />
                </div>
                <div className="container col-lg-6 rbt-section-gapTopHalf">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <div className="section-title text-start">
                      <h4 className="title">Proceso de Admisión 2027 </h4>
                      <p className="description mt--20 mb--20">
                        Conoce cómo hacer parte de nuestra comunidad Menfisiana
                      </p>
                      <p className="description mb--20">
                        Te invitamos a visitar nuestro campus y descubrir por qué el Colegio Menfis es un lugar de aprendizajes significativos. Durante tu visita podrás conocer a nuestro equipo docente, recorrer nuestras instalaciones y conversar sobre nuestro enfoque educativo integral y bilingüe.
                      </p>
                      <p className="description mb--20">
                        Después de este encuentro, agendaremos una entrevista personalizada para iniciar el proceso de admisión para el año 2027.
                      </p>
                      <p className="description mb--20">
                        Para conocer mejor a tu hijo o hija, solicitaremos observadores, calificaciones de años anteriores y cualquier información relevante sobre su desarrollo o necesidades específicas.
                      </p>
                      <Image
                        className="w-100 rbt-radius"
                        src={pricing2026Img}
                        width={407}
                        height={638}
                        property="true"
                        alt="tuition fees 2026"
                      />
                      <p className="description mb--20">
                        Recuerda que para reservar el cupo no es necesario realizar ningún pago.
                      </p>
                      <p className="description mb--20">
                        En 2027, el grado de ingreso será Transición, para niños con 5 años cumplidos o próximos a cumplir. El grado más alto ofertado será Undécimo.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" bg-color-white rbt-section-gapTopHalf flex-center">
            <div className="container col-lg-8">
              <h4 className="title">
                Restaurante Escolar
              </h4>
              <p className="description mb--20">
                Nuestro restaurante escolar ha sido todo un éxito entre las familias Menfisianas. Cada día, más del 60% de nuestros estudiantes disfrutan de menús balanceados y deliciosos que contribuyen a su bienestar y concentración durante la jornada.
              </p>
              <p className="description mb--20">
                 Porque una buena alimentación también hace parte del aprendizaje.
              </p>
              <h4 className="title">
               En el Colegio Menfis, el bilingüismo es una experiencia viva y constante. Contamos con:
              </h4>
              <div className="rbt-feature-wrapper mt--40">
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">
                      Aulas semi-personalizadas con grupos entre 15 y 18 estudiantes, garantizando atención individual y acompañamiento cercano.
                    </h6>
                  </div>
                </div>
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-secondary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">
                      Profesores nativos de países como Inglaterra, Estados Unidos y Canadá, que comparten su cultura y enseñan inglés de forma vivencial y experiencial.
                    </h6>
                  </div>
                </div>
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">
                      Familias extranjeras que hacen parte de nuestra comunidad, enriqueciendo el entorno cultural y fortaleciendo el aprendizaje del idioma.
                    </h6>
                  </div>
                </div>
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-secondary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">Jornada completa de lunes a jueves.</h6>
                  </div>
                </div>
                {/* <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">
                      Curso adicional de refuerzo de inglés para estudiantes y familias Menfisianas, con un costo adicional.
                    </h6>
                  </div>
                </div> */}
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">
                      Semilleros de investigación, donde la curiosidad se convierte en conocimiento. 
                    </h6>
                  </div>
                </div>
              </div>
              <h4 className="title mt--40">
                Además, ofrecemos actividades lúdicas opcionales en:
              </h4>
              <div className="rbt-feature-wrapper mt--30 short-list-items">
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">Natación</h6>
                  </div>
                </div>
                <div className="rbt-feature feature-style-1 align-items-center">
                  <div className="icon bg-secondary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">Fútbol mixto</h6>
                  </div>
                </div>
                <div className="rbt-feature feature-style-1 align-items-center ">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-check-square"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">Ajedrez</h6>
                  </div>
                </div>
              </div>
              <h4 className="title mt--30">
                ¡Anímate a ser parte de nuestra comunidad educativa!
              </h4>
              <p className="description mb--20">
                El proceso de admisión para el año <b>2027</b> ya está en marcha.
              </p>
              <p className="description mb--20">
                Da el primer paso hacia una educación <b>bilingüe, integral y transformadora.</b>
              </p>
              <Link 
                className="rbt-moderbt-btn mb--30 mt--15" 
                href='https://forms.zohopublic.com/daniel104/form/ReservadecupoColegioMenfis2027/formperma/hkgJC8jbOl0QPHzJj5tyOr54hOYi9P6UJW7AIfbVsCo' 
                target="_blank"> 
                  Postúlate en este enlace
              </Link>
              <h4 className="title mb--30">
                Let’s go!
              </h4>
            </div>
          </div>
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default Enrolment;
